module.exports = __webpack_public_path__ + "img/pfizer.60b9a21f.png";